import {
	Routes,
	Route,
	Navigate,
	useLocation,
	useNavigate,
} from "react-router-dom";
import { useEffect } from "react";
import Sidebar from "./components/Sidebar";
import Topbar from "./components/Topbar";

import Dashboard from "./pages/Dashboard";
import Messages from "./pages/Messages";
import Logs from "./pages/Logs";
import ResetPassword from "./pages/ResetPassword";
import Logout from "./pages/Logout";
import LoginPage from "./pages/LoginPage";
import OtpPage from "./pages/OtpPage";
import CreateUser from "./pages/CreateUser";
import NotFound from "./pages/NotFound";
import InternationalMessages from "./pages/InternationalMessages";

const RequireAuth = ({ children }) => {
	const token = sessionStorage.getItem("token");
	const location = useLocation();

	if (!token) {
		return <Navigate to='/login' state={{ from: location }} replace />;
	}

	return children;
};

const RedirectIfAuth = ({ children }) => {
	const token = sessionStorage.getItem("token");

	if (token) {
		return <Navigate to='/' replace />;
	}

	return children;
};

const App = () => {
	const location = useLocation();
	const navigate = useNavigate();

	// Hide sidebar/topbar for these routes
	const noLayoutPaths = ["/login", "/otp"];
	const hideLayout = noLayoutPaths.includes(location.pathname);

	// 🔐 Check sessionStorage every 1 minute
	useEffect(() => {
		const interval = setInterval(() => {
			const token = sessionStorage.getItem("token");
			if (!token) {
				navigate("/login");
			}
		}, 60 * 1000); // every 60 seconds

		return () => clearInterval(interval);
	}, [navigate]);

	return (
		<div className='flex h-screen bg-gray-50 overflow-hidden'>
			{!hideLayout && (
				<aside className='w-64 shrink-0 bg-white border-r'>
					<Sidebar />
				</aside>
			)}
			<div className='flex-1 flex flex-col overflow-x-auto'>
				{!hideLayout && <Topbar />}

				<main className='flex-1 p-6 min-w-[800px]'>
					<Routes>
						<Route
							path='/login'
							element={
								<RedirectIfAuth>
									<LoginPage />
								</RedirectIfAuth>
							}
						/>
						<Route
							path='/otp'
							element={
								<RedirectIfAuth>
									<OtpPage />
								</RedirectIfAuth>
							}
						/>
						<Route
							path='/'
							element={
								<RequireAuth>
									<Dashboard />
								</RequireAuth>
							}
						/>
						<Route
							path='/messages'
							element={
								<RequireAuth>
									<Messages />
								</RequireAuth>
							}
						/>

						<Route
						path='/messages/international'
						element={
							<RequireAuth>
								<InternationalMessages />
							</RequireAuth>
						}
					/>
						<Route
							path='/logs'
							element={
								<RequireAuth>
									<Logs />
								</RequireAuth>
							}
						/>
						<Route
							path='/reset-password'
							element={
								<RequireAuth>
									<ResetPassword />
								</RequireAuth>
							}
						/>
						<Route
							path='/create-user'
							element={
								<RequireAuth>
									<CreateUser />
								</RequireAuth>
							}
						/>
						<Route path='/logout' element={<Logout />} />
						<Route path='*' element={<NotFound />} />
					</Routes>
				</main>
			</div>
		</div>
	);
};

export default App;
